module.exports = __webpack_public_path__ + "assets/ResultsPauseButton.bd4dc45e.svg";